import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Hastalar from './pages/Hastalar';
import HastaDetay from './pages/HastaDetay';
import HastaForm from './pages/HastaForm';
import Randevular from './pages/Randevular';
import MuayeneGecmis from './pages/MuayeneGecmis';
import MuayeneDetay from './pages/MuayeneDetay';
import MuayeneYeni from './pages/MuayeneYeni';
import Muayeneler from './pages/Muayeneler';
import Faturalar from './pages/Faturalar';
import Tahsilatlar from './pages/Tahsilatlar';
import Harcamalar from './pages/Harcamalar';
import Odemeler from './pages/Odemeler';
import Kasa from './pages/Kasa';
import RandevuVer from './pages/RandevuVer';
import RandevuVerPublic from './pages/RandevuVerPublic';
import SifreDegistir from './pages/SifreDegistir';
import './App.css';

function KorunanRoute({ children }) {
  const kullanici = localStorage.getItem('kullanici');
  return kullanici ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter basename="/klinik">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/randevu-public/:siteId/:dokKod" element={<RandevuVerPublic />} />
        <Route path="/" element={<KorunanRoute><Layout /></KorunanRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="hastalar" element={<Hastalar />} />
          <Route path="hasta-yeni" element={<HastaForm />} />
          <Route path="hasta/:kayitNo" element={<HastaDetay />} />
          <Route path="hasta/:kayitNo/duzenle" element={<HastaForm />} />
          <Route path="randevular" element={<Randevular />} />
          <Route path="randevu-ver" element={<RandevuVer />} />
          <Route path="muayeneler" element={<Muayeneler />} />
          <Route path="hasta/:kayitNo/muayeneler" element={<MuayeneGecmis />} />
          <Route path="hasta/:kayitNo/muayene-yeni" element={<MuayeneYeni />} />
          <Route path="muayene/:id" element={<MuayeneDetay />} />
          <Route path="faturalar"   element={<Faturalar />} />
          <Route path="tahsilatlar" element={<Tahsilatlar />} />
          <Route path="harcamalar"  element={<Harcamalar />} />
          <Route path="odemeler"    element={<Odemeler />} />
          <Route path="kasa"        element={<Kasa />} />
          <Route path="sifremi-degistir" element={<SifreDegistir />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
